import axios from 'axios'
import { core } from '@/config/pluginInit'
import { VUE_APP_BASEURL } from './config/constant'

export const apiHeader = () => {
  return {
    Authorization: localStorage.getItem('userToken') ? `Bearer ${JSON.parse(localStorage.getItem('userToken'))}` : null,
    Accept: 'application/json',
    ContentType: 'application/json',
    'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ar',
    'Content-Language': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ar',
    'Country-id': localStorage.getItem('country') ? localStorage.getItem('country') : '',
    'City-id': localStorage.getItem('city') ? localStorage.getItem('city') : ''
  }
}
export const apiResponseCatch = (error) => {
  if (error?.response?.data?.errors && JSON.stringify(error?.response?.data?.errors) !== '{}') {
    // eslint-disable-next-line no-prototype-builtins
    if (error.response.data.errors?.hasOwnProperty('translations')) {
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(error.response.data.errors.translations)) {
        core.showSnackbar('error', value)
      }
    } else {
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(error.response.data.errors)) {
        core.showSnackbar('error', value)
      }
    }
  } else if (error?.response?.data) {
    core.showSnackbar('error', error.response.data.message)
  }
  return Promise.reject(error)
}

export function singleSignOn () {
  const apiClient = axios.create({
    baseURL: VUE_APP_BASEURL,
    headers: apiHeader()
  })
  apiClient.interceptors.response.use((response) => {
    return response
  }, apiResponseCatch)
  return apiClient
}

export function marketPlace () {
  const apiClient = axios.create({
    baseURL: VUE_APP_BASEURL,
    headers: apiHeader()
  })
  apiClient.interceptors.response.use((response) => {
    return response
  }, apiResponseCatch)
  return apiClient
}

export function joining () {
  const apiClient = axios.create({
    baseURL: VUE_APP_BASEURL,
    headers: apiHeader()
  })
  apiClient.interceptors.response.use((response) => {
    return response
  }, apiResponseCatch)
  return apiClient
}

export function website () {
  const apiClient = axios.create({
    baseURL: VUE_APP_BASEURL,
    headers: apiHeader()
  })
  apiClient.interceptors.response.use((response) => {
    return response
  }, apiResponseCatch)
  return apiClient
}
